import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import './App.css';
import { SettingsProvider } from './lib/SettingsContext';
import { useUnlocked } from './lib/useUnlocked';
import Navigation from './components/Navigation';
import CalculatorPage from './pages/CalculatorPage';
import GuidedPage from './pages/GuidedPage';
import PricingSheetPage from './pages/PricingSheetPage';
import QuotePage from './pages/QuotePage';
import SettingsPage from './pages/SettingsPage';
import FAQPage from './pages/FAQPage';
import SalesPage from './pages/SalesPage';

/**
 * The customer-facing quote is the one route without internal navigation — a
 * prospect opening a shared link should see their quote, not our sales tools.
 */
/**
 * Staff routes are reachable only with ?change=true. Gating the menu alone
 * would leave the pages one typed URL away, so the routes redirect too.
 */
const StaffOnly = ({ children }) => (useUnlocked() ? children : <Navigate to="/guided" replace />);

const Shell = () => {
    const location = useLocation();
    const isCustomerView = location.pathname.startsWith('/q/');

    return (
        <div className="App">
            {!isCustomerView && <Navigation />}
            <main>
                <Routes>
                    <Route path="/" element={<StaffOnly><CalculatorPage /></StaffOnly>} />
                    <Route path="/guided" element={<GuidedPage />} />
                    <Route path="/pricing" element={<PricingSheetPage />} />
                    <Route path="/q/:id" element={<QuotePage />} />
                    <Route path="/settings" element={<StaffOnly><SettingsPage /></StaffOnly>} />
                    <Route path="/faq" element={<StaffOnly><FAQPage /></StaffOnly>} />
                    <Route path="/sales" element={<StaffOnly><SalesPage /></StaffOnly>} />
                </Routes>
            </main>
        </div>
    );
};

function App() {
    return (
        // Calculation settings load once here, so every surface prices on the
        // same calibration.
        <SettingsProvider>
            <Router>
                <Shell />
            </Router>
        </SettingsProvider>
    );
}

export default App;
